// extracted by mini-css-extract-plugin
module.exports = {"pst-root":"PartialSuccessTable_pst-root__3uthU","partial-success-table":"PartialSuccessTable_partial-success-table__2gvaq"};